var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category-dishes-swiper"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('swiper',{ref:"mySwiper",staticClass:"dishes-slider",attrs:{"options":_vm.swiperOptions}},[_vm._l((_vm.dishes),function(dish){return _c('swiper-slide',{key:dish.ID},[_c('dish',{attrs:{"dish":dish}})],1)}),_vm._v(" "),_c('div',{staticClass:"dishes-slider-pagination",attrs:{"slot":"pagination"},slot:"pagination"})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CategoryDishesSwiper.vue?vue&type=template&id=521c17d0&
// module id = 724
// module chunks = 2